import BusinessCenterRoundedIcon from "@mui/icons-material/BusinessCenterRounded";
// import LocalOfferRoundedIcon from "@mui/icons-material/LocalOfferRounded";
// import HeadsetMicRoundedIcon from "@mui/icons-material/HeadsetMicRounded";
import SettingsApplicationsRoundedIcon from "@mui/icons-material/SettingsApplicationsRounded";
import { Divider } from "@mui/material";
import { t } from "i18next";
import React, { useEffect, useState } from "react";
import ChatBot from "./ChatBot";
import { useSelector } from "react-redux";
import ButtonBot from "./ButtonBot";
import CoreButtonHoverIcon from "../../../app/core/components/CoreButtonIcon/CoreButtonHoverIcon";
import { useNavigate } from "react-router-dom";
import { useGetAllBotQuery } from "../../api/admin/chatbotApi";

const ChatBotPage = () => {
  const navigate = useNavigate();
  const [openBot, setOpenBot] = useState(false);
  const [bots, setBots] = useState();
  const [idBot, setIdBot] = useState();
  const colorPrimary = useSelector((state) => state.app.primaryColor);
  const appConfig = useSelector((state) => state.app.appConfig);

  const { data: getAllBot } = useGetAllBotQuery(undefined, {
    skip: !appConfig?.modules?.chatBot?.settingsBot,
  });

  useEffect(() => {
    if (getAllBot && getAllBot.Data) {
      setBots(getAllBot.Data.value);
    }
  }, [getAllBot]);

  const handleSelectedBot = (bot) => {
    setOpenBot(!openBot);
    setIdBot(bot);
  };

  const handleSelectedDefault = () => {
    setOpenBot(!openBot);
    setIdBot();
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <h2>{t("SmartAssistant")}</h2>
      </div>
      {appConfig?.modules?.chatBot?.settingsBot && (
        <CoreButtonHoverIcon
          onClick={() => navigate("/auth/admin/chat-bot-settings")}
          className="text-green-700 m-1"
          icon={
            <SettingsApplicationsRoundedIcon className={`fill-green-700 `} />
          }
          testo={t("Settings")}
        />
      )}
      <div className="flex h-[900px] mt-5">
        <div
          className="w-3/12 h-full flex flex-col space-y-4 mr-4 overflow-auto"
          style={{ maxWidth: "900px" }}
        >
          <h3 style={{ color: `${colorPrimary}` }}>{t("DefaultAgent")}</h3>
          <ButtonBot
            disabled={openBot && idBot}
            style={
              openBot && idBot
                ? { color: `lightgrey`, borderColor: `lightgrey` }
                : {
                    color: `${colorPrimary}`,
                    borderColor: `${colorPrimary}`,
                  }
            }
            onOpen={handleSelectedDefault}
            icon={<BusinessCenterRoundedIcon />}
            iconText={"Fiscale"}
            text={
              "Un assistente dedicato alle conoscenze specifiche, come la fiscalità e sullo stato pratiche dei tuoi contribuenti"
            }
          />

          {appConfig?.modules?.chatBot?.settingsBot && bots && (
            <>
              <h3 style={{ color: `${colorPrimary}` }}>{t("CustomAgent")}</h3>
              {bots?.map((el) => (
                <>
                  <ButtonBot
                    key={el.id}
                    disabled={openBot && idBot !== el.id}
                    style={
                      openBot && idBot !== el.id
                        ? { color: `lightgrey`, borderColor: `lightgrey` }
                        : {
                            color: `${colorPrimary}`,
                            borderColor: `${colorPrimary}`,
                          }
                    }
                    onOpen={() => handleSelectedBot(el.id)}
                    img={el.iconUrl}
                    iconText={el.name}
                    text={el.description}
                  />
                  <Divider />
                </>
              ))}
            </>
          )}
        </div>

        <div
          className={"w-9/12 h-full rounded-lg"}
          style={{
            border: "1px solid lightgrey",
          }}
        >
          {openBot ? (
            <ChatBot idBot={idBot} />
          ) : (
            <p className="w-full h-full text-lightgray flex justify-center items-center text-xl">
              {t("NotSelectedAgent")}
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default ChatBotPage;
